export const NO_AUTH_HEADER = "x-no-auth";
export const IF_MATCH_HEADER = "If-Match";
export const CORRELATION_BAGGAGE_HEADER = "X-Correlation-Baggage";
export const ERROR_TYPE_HEADER = "x-error-type";
